<template>
    <div id="addresses">
        <OrkLoader :loading="loadingAddress">
            <transition>
                <div v-if="customer" class="addresses__content">
                    <SfHeading
                            :level="2"
                            :title="$t('Delivery address')"
                            class="sf-heading--no-underline"
                    />
                    <div class="block">
                        <div v-if="customer.addresses.length===0" class="no-address">

                            <p>{{ $t('Please add a delivery address') }}.</p>
                            <p class="error">
                                {{ $t('No saved addresses') }}
                            </p>
                            <SfButton @click="toggleAddressModal"> {{ $t('add new address') }}</SfButton>
                        </div>

                        <div v-else class="addresses">
                            <div class="intro">
                                <p class="text">{{
                                    $t('Please select a delivery address or ')
                                    }}
                                    <SfButton class="inline-btn sf-button--text color-tertiary"
                                              @click="toggleAddressModal">
                                        {{ $t('create new one') }}
                                    </SfButton>
                                </p>
                            </div>
                            <div v-if="customer.addresses && customer.addresses.length>0" class="addresses-content">
                                <UserAddress v-for="address in customer.addresses" :key="address.name"
                                             :address="address"
                                             :isSelected="selectedAddress===address.name"
                                             :show-address-name="false"
                                             v-bind="customer.address"
                                             @setAddress="setShippingAddress($event)"></UserAddress>
                                <!--relais
                                <UserAddress v-if="selectedRelais" :address="selectedRelais" :isRelais="true"
                                             :isSelected="selectedAddress===selectedRelais.name"
                                             :show-address-name="false"
                                             v-bind="selectedRelais"
                                             @setAddress="setRelais(selectedRelais)"></UserAddress>
                                -->
                            </div>

                        </div>

                    </div>
                </div>
            </transition>
        </OrkLoader>
        <OrkLoader v-if="selectedAddress" :loading="loadingAddress || loadingShipment">
            <transition>
                <div class="shipping__content">
                    <SfHeading
                            :level=2
                            :title="$t('Delivery options')"
                            class=" sf-heading--no-underline title"
                    />

                    <UserShipmentOptions v-if="shipmentMethods && shipmentMethods.length>0"
                                         :selectedMethods="selectedMethods"
                                         :selectedRelais="selectedRelais"
                                         :shipmentMethods="shipmentMethods"
                                         @openRelais="toggleColissimoModal"
                                         @removeRelais="removeRelais"
                                         @submitSelectedShipmentMethod="setShipmentMethods"
                    />
                    <div v-else class="shipping_content">
                        <SfNotification :message="$t('no shipping method found for this address')" :persistent="true"
                                        :visible="true"
                                        class="noshipping"></SfNotification>
                    </div>
                </div>

            </transition>
        </OrkLoader>


        <div class="checkout actions">
            <SfButton
                    class='sf-button color-white'
                    type='button'
                    @click="goBack()"
            >
                {{ $t('Edit my shopping cart') }}
            </SfButton>

            <SfButton
                    :disabled="!selectedMethods.length>0 || !isDone || loading "
                    aria-disabled="true"
                    class='sf-button color-secondary'
                    @click="submitStep"
            >
        <span v-if="loading">
        <SfLoader :class="{ loader: loading }" :loading="loading"></SfLoader>
            {{ $t('Loading') }}
        </span>
                <span v-else>
        {{ $t('Next step') }}
        </span>
            </SfButton>
        </div>
    </div>

</template>

<script>

import {SfButton, SfHeading, SfLoader, SfNotification, SfTextarea, SfRadio, SfImage} from "@storefront-ui/vue";
import UserAddress from "@/components/UserAddress.vue";
import OrkLoader from "@/components/Ork/OrkLoader";
import UserShipmentOptions from "@/components/Checkout/UserShipmentOptions";
import Api from "@/api/Api";

import {ShipmentMethods} from "@/models/shipment";
import icons from "@/utils/icons";
import {Customer} from "@/models/customer";
import {RelaistoAddress} from "@/models/address";
import GtagEvent from "@/utils/GtagEvent";
import _ from "lodash";


export default {
    name: "Shipping",

    components: {
        SfImage,
        SfRadio,
        SfNotification,
        SfTextarea,
        OrkLoader,
        UserShipmentOptions,
        SfHeading,
        SfButton,
        SfLoader,
        UserAddress,

    },
    data() {
        return {
            error: null,
            loadingShipment: false,
            loadingAddress: false,
            shippingAddress: null,
            shipmentMethods: null,
            isDone: false,
            selectedAddress: null,
            selectedRelaisId: null,
            selectedMethods: [],
            loading: false,
            icons: icons,
        };
    },
    created() {
        this.isDone = false;
        this.$emit("isDoneShipping", false);
    },
    mounted() {
        this.isDone = false;
        this.$emit("isDoneShipping", false);
        this.getShippingAddress();

        if (this.currentCart) {
            GtagEvent.beginCheckout(this.currentCart)
        }
    },

    computed: {
        selectedRelais: {
            get() {
                return this.$store.getters.getSelectedRelais;
            },
        },
        customer: {
            get() {
                return this.$store.getters.getProfile;
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            set() {

            },
        },
        currentCart: {
            get() {
                return this.$store.getters.getCart;
            },
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            set() {

            },
        },
    },
    watch: {
        customer(newCustomer, oldCustomer) {
            this.getShippingAddress();

        },
        selectedRelais(newRelay, oldRelay) {

            if (!oldRelay) {
                if (!newRelay) {
                    this.setRelais(true);
                } else {
                    this.setRelais(true);
                }
            } else {
                if (newRelay && newRelay.name !== oldRelay.name) {
                    this.setRelais(false);
                } else {
                    this.setRelais(true);
                }
            }
        },
        currentCart(newCart, oldCart) {
            if (!newCart && !oldCart) {
                this.$router.push(this.$localizePath('/mon-panier')).catch();
            }
        },
        shippingAddress(newAddress, oldAddress) {

            if (this.currentCart && newAddress && oldAddress && newAddress.name !== oldAddress.name) {
                this.setShippingAddress(newAddress);
            }
            if (this.currentCart && newAddress && newAddress.name) {
                this.setShippingAddress(newAddress);
            }
        }
    },
    methods: {
        getShippingAddress() {

            let isRelais = null
            if (this.currentCart) {
                isRelais = this.currentCart.shipments[0].address?.name?.split("relay_").length > 1;
            }
            if (isRelais) {

                this.selectedAddress = this.currentCart.shipments[0].address.name;
                this.selectedRelaisId = this.currentCart.shipments[0].address.name;
                this.selectedMethods[0] = this.currentCart.shipments[0]?.shipmentMethod?.id ? this.currentCart.shipments[0].shipmentMethod.id : null;
                this.$store.dispatch("toggleColissimoModal", {
                    open: false,
                    selectedRelais: this.currentCart.shipments[0].address,
                    shipmentWeight: this.currentCart.shipments[0].shipmentWeight,
                });
                this.setRelais()


            } else {

                if (this.customer && this.customer.defaultShippingAddress && this.customer.addresses?.length !== 0) {
                    const defaultShippingAddress = this.customer.addresses.find(address => address.name === this.customer.defaultShippingAddress) || null;
                    //check if it has a selected address
                    if (this.currentCart && this.currentCart.shipments[0].address) {


                        // Shopping cart has an address set
                        if (this.customer.addresses.find(address => address.name === this.currentCart.shipments[0].address.name)) {
                            this.selectedAddress = this.currentCart.shipments[0].address.name || defaultShippingAddress.name;
                            this.selectedMethods[0] = this.currentCart.shipments[0]?.shipmentMethod?.id ? this.currentCart.shipments[0].shipmentMethod.id : null;

                            if (this.selectedMethods[0]) {
                                this.shippingAddress = this.currentCart.shipments[0].address || defaultShippingAddress
                            } else {
                                if (defaultShippingAddress) {
                                    this.shippingAddress = defaultShippingAddress
                                }
                            }
                        }
                    } else {
                        this.selectedAddress = defaultShippingAddress.name
                        this.shippingAddress = defaultShippingAddress
                    }
                }
            }

        },
        setShippingAddress(address, refreshShipmentMethods = true) {

            let isRelay = address.name.split('relay_').length > 1 || null;
            this.loadingShipment = true
            this.isDone = false;
            this.selectedRelaisId = isRelay ? this.selectedRelaisId : null;

            this.$emit("isDoneShipping", false);

            this.selectedAddress = address ? address.name : undefined;

            this.$store.dispatch("toggleColissimoModal", {
                open: false,
                selectedRelais: isRelay ? this.selectedRelais : null,
                shipmentWeight: this.currentCart.shipments[0].shipmentWeight,
            });

            return Api.cart.setShippingAddress(address)
                .then((data) => {

                    this.$store.dispatch("setCart", data);
                    this.currentCart = data;

                    if (refreshShipmentMethods) {
                        this.getShipmentMethods();
                    }
                })
                .catch((e) => {
                    this.isDone = false;
                    this.$emit("isDoneShipping", false);
                    let error = null;
                    switch (e.status) {
                        case 400:
                            error = this.$i18n.t("errors.cart.stock");
                            break;
                        case 401:
                            error = this.$i18n.t("errors.cartAdresse.unauthorized");
                            break;
                        case 409:
                            error = this.$i18n.t("errors.cartAdresse.allReadyExist");
                            break;
                        case 499:

                            break;
                        default:
                            error = this.$i18n.t("errors.server.access");
                            console.error(e)
                            break

                    }
                    if (error) {
                        this.$store.dispatch("sendNotification", {type: "danger", message: error, icon: "error"});
                    }
                })
                .finally(() => {
                    this.loadingAddress = false;
                });
        },
        goBack() {
            this.$router.push(this.$localizePath("/mon-panier")).catch();
        },
        getShipmentMethods() {
            this.loadingShipment = true;
            this.isDone = false;
            this.$emit("isDoneShipping", false);

            Api.cart.getShipmentMethods()
                .then((data) => {

                    this.shipmentMethods = [];
                    if (data.length > 0) {
                        for (let ShipmentMethod of data[0]) {
                            this.shipmentMethods.push(ShipmentMethods.of(ShipmentMethod));
                        }

                        this.shipmentMethods.sort((a, b) => {
                            return a.price.taxIncluded > b.price.taxIncluded ? 1 : -1;
                        });

                        this.loadingShipment = false;
                        if (this.selectedMethods && this.selectedMethods.length > 0) {
                            const selectedMethodObj = this.shipmentMethods.find(method => this.selectedMethods.includes(method.id));

                            if (selectedMethodObj) {
                                this.setShipmentMethods(selectedMethodObj.id);

                            } else {
                                this.selectedMethods = [];
                                this.isDone = false;
                                this.$emit("isDoneShipping", false);
                                if (this.shipmentMethods && this.shipmentMethods.length === 1) {
                                    this.setShipmentMethods(this.shipmentMethods[0].id);
                                }
                            }
                        } else {
                            if (this.shipmentMethods && this.shipmentMethods.length === 1) {
                                this.setShipmentMethods(this.shipmentMethods[0].id);
                            }
                        }
                    } else {
                        this.$store.dispatch("sendNotification", {
                            type: "danger",
                            message: this.$i18n.t("errors.noshipment"),
                            icon: icons.error,
                        });
                    }

                })
                .catch((e) => {
                    this.shipmentMethods = [];
                    this.selectedMethods = [];
                    this.isDone = false;
                    this.$emit("isDoneShipping", false);
                })
                .finally(() => {
                    this.loadingShipment = false;
                });
        },

        submitStep() {
            this.loading = true;
            if (this.isDone) {
                this.$emit("isDoneShipping", true);
                this.$router.push(this.$localizePath("/commande/paiement")).catch();
            }
        },
        toggleColissimoModal() {

            const shippingAddress = Customer.getAddress(this.customer, this.selectedAddress) || Customer.getAddress(this.customer, this.customer.defaultShippingAddress);
            let address = {street: null, city: null, country: null, postCode: null, phone: null}
            if (shippingAddress) {
                address = {
                    street: shippingAddress.street,
                    postCode: shippingAddress.postCode,
                    city: shippingAddress.city,
                    country: shippingAddress.country,
                    phone: shippingAddress.phone,
                };
            }
            this.$store.dispatch("toggleColissimoModal", {
                open: true,
                address,
                selectedRelais: this.selectedRelais,
                shipmentWeight: this.currentCart.shipments[0].shipmentWeight,
            });
        },
        removeRelais() {
            this.$store.dispatch("toggleColissimoModal", {
                open: false,
                selectedRelais: null,
            });
            this.isDone = false;
            this.$emit("isDoneShipping", false);
            this.selectedAddress = this.customer.addresses.find(address => address.name === this.customer.defaultShippingAddress).name;
            this.shippingAddress = this.customer.addresses.find(address => address.name === this.customer.defaultShippingAddress)


        },
        setRelais(reload = true) {

            if (!this.selectedRelais) {
                return;
            }

            this.selectedAddress = this.selectedRelais.name;
            let address = RelaistoAddress.of({customer: this.customer, relais: this.selectedRelais});
            if (!reload) {
                this.setShippingAddress(address, false).then(() => {
                    this.loadingShipment = false
                    if (this.selectedMethods.length > 0) {
                        Api.cart.setShipmentMethods(this.selectedMethods)
                            .then((data) => {
                                this.$store.dispatch("setCart", data);
                                this.selectedRelaisId = address.name;
                                this.isDone = true;
                            })
                            .catch((e) => {
                                this.isDone = false;
                                let error = null;
                                switch (e.status) {
                                    case 400:
                                        error = this.$i18n.t("errors.cart.stock");
                                        break;
                                    case 401:
                                        error = this.$i18n.t("errors.shipmentMethod.unauthorized");
                                        break;
                                    case 409:
                                        error = this.$i18n.t("errors.shipmentMethod.allReadyExist");
                                        break;
                                    case 499:
                                        break;
                                    default:
                                        error = this.$i18n.t("errors.server.access");
                                        console.error(e)
                                        break
                                }
                                if (error) {
                                    this.$store.dispatch("sendNotification", {
                                        type: "danger",
                                        message: error,
                                        icon: "error"
                                    });
                                }
                            })
                            .finally(() => {
                                this.$emit("isDoneShipping", this.isDone);
                                this.loading = false;
                                this.loadingShipment = false
                            });
                    } else {
                        this.isDone = false;
                        this.$emit("isDoneShipping", false);
                        this.loading = false;

                    }
                });
            } else {
                this.setShippingAddress(address, true)
            }
        },

        setShipmentMethods(selectedMethodId) {
            let isRelay = this.selectedAddress ? this.selectedAddress.split('relay_').length > 1 || null : null;
            this.selectedMethods = [selectedMethodId];
            const selectedMethodObj = this.shipmentMethods.find(method => method.id === selectedMethodId);
            this.isDone = false;
            this.$emit("isDoneShipping", false);
            if ((!isRelay && selectedMethodObj.carrier !== 'A2P') || (isRelay && selectedMethodObj.carrier === 'A2P')) {
                this.loading = true;
                Api.cart.setShipmentMethods(this.selectedMethods)
                    .then((data) => {

                        this.$store.dispatch("setCart", data);
                        this.isDone = true;
                        this.$emit("isDoneShipping", true);
                    })
                    .catch((e) => {
                        this.isDone = false;
                        this.$emit("isDoneShipping", false);
                        let error = null;
                        switch (e.status) {
                            case 401:
                                error = this.$i18n.t("errors.shipmentMethod.unauthorized");
                                break;
                            case 409:
                                error = this.$i18n.t("errors.shipmentMethod.allReadyExist");
                                break;
                            case 499:

                                break;
                            case 400:
                                Api.cart.getCart(this.currentCart.id)
                                    .then((cart) => {
                                        this.$store.dispatch('setCart', cart);
                                        this.getShipmentMethods();
                                    }).catch((e) => {
                                    this.$store.dispatch("sendNotification", {
                                        type: "danger",
                                        message: "errors.server.access",
                                        icon: "error"
                                    });
                                });

                                this.$store.dispatch("sendNotification", {
                                    type: "danger",
                                    message: "errors.payment.reload",
                                    icon: "error"
                                });
                                break;
                            default:
                                error = this.$i18n.t("errors.server.access");
                                console.error(e)
                                break
                        }
                        if (error) {
                            this.$store.dispatch("sendNotification", {type: "danger", message: error, icon: "error"});
                        }
                    }).finally(() => {
                    this.loading = false;
                    this.loadingShipment = false

                });
            } else {
                this.loadingShipment = false
            }
        },
        toggleAddressModal() {
            this.$store.dispatch("toggleAddressModal");
        },
    },
};
</script>

<style lang="scss" scoped>
.addresses {
  &-content {
    display: grid;
    gap: 20px;
    grid-template-columns:  repeat(3, minmax(0, 1fr));
    @include for-desktop-small {
      grid-template-columns:  repeat(2, minmax(0, 1fr));
    }
    @include for-tablet {
      grid-template-columns:  repeat(3, minmax(0, 1fr));
    }
    @include for-mobile {
      grid-template-columns:  repeat(1, minmax(0, 1fr));
    }
  }

  .intro {
    display: flex;
    margin: var(--spacer-sm) auto var(--spacer-base);
    justify-content: center;

    .text {
      display: inline-block;

      .inline-btn {
        margin-left: 0;
        display: inline-block;
      }
    }
  }
}

.shipping__actions {
  display: flex;
  flex-wrap: wrap;
  margin-top: var(--spacer-xl);
  justify-content: space-between;
}

.shipping__actions > button.sf-button {
  display: inline-block;
  margin-bottom: var(--spacer-base);

}

/**************/
.block {
  border-radius: 4px;
  border: 1px solid var(--_c-lightgray);
  padding: var(--spacer-base);
  margin: var(--spacer-sm) 0 var(--spacer-lg);
  @include for-mobile {
    padding: var(--spacer-sm);
  }

  p {
    margin-top: 0;

    &.error {
      color: var(--c-danger);
      font-weight: bold;
    }
  }
}

.user-address {
  cursor: pointer;
}

.checkout.actions {
  margin: auto 0 0 0;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: space-between;
  @include for-mobile {

  }

  .sf-button {
    width: fit-content;

    white-space: nowrap;
    min-height: 32px;
    padding: var(--spacer-sm) var(--spacer-sm);
    margin: var(--spacer-xs);

    &:first-of-type:not(:last-of-type) {
      margin: var(--spacer-sm) var(--spacer-sm) var(--spacer-sm) 0;
    }

    &:last-of-type:not(:first-of-type) {
      margin: var(--spacer-sm) 0 var(--spacer-sm) var(--spacer-sm);
    }

    @include for-mobile {
      flex: 100%;
      width: 100%;
      &:first-of-type:not(:last-of-type) {
        margin: var(--spacer-sm) 0;
      }
      &:last-of-type:not(:first-of-type) {
        margin: var(--spacer-sm) 0 0;
      }
    }
  }
}
</style>
